import { css } from '@emotion/react';
import rem from './rem';
import remToPxValue from './remToPxValue';
import { bottomShadow, topShadow, } from './shadow';
import theme from './theme';
const buttonReset = css `
  border: none;
  border-radius: 0;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;

  &:focus {
    outline: none;
    box-shadow: none;
  }
`;
const resetAll = css `
  position: static;
  float: none;
  width: auto;
  height: auto;
  clear: both;
  margin: 0;
  border: 0;
  padding: 0;
`;
const listReset = css `
  list-style: none;
  padding: 0;
  margin: 0;
`;
const borderBox = css `
  &,
  & * {
    box-sizing: border-box;
  }
`;
const transition = (...properties) => (css `
    transition-duration: ${theme.durationDefault};
    transition-property: ${properties.join(',')};
    transition-timing-function: ${theme.easingDefault};
  `);
const flexCenter = css `
  display: flex;
  justify-content: center;
  align-items: center;
`;
// scales text based on vw. base is target font size (unitless # representing
// px) at the breakpont (in rems, usually should pass a theme breakpoint var
// here)
export const scalePxToVw = (base, breakpoint) => (`${base / (parseInt(breakpoint, 10) * 16 * 0.01)}vw`);
/**
 * To make for example the heading hierarchy semantically correct or adding icon titles for a11y
 * @see https://www.joshwcomeau.com/snippets/react-components/visually-hidden/
 */
const visuallyHidden = css `
  border: 0;
  clip: rect(0 0 0 0);
  display: inline-block;
  height: 0;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 0;
`;
const styleUtils = {
    borderBox,
    bottomShadow,
    buttonReset,
    flexCenter,
    listReset,
    rem,
    remToPxValue,
    resetAll,
    topShadow,
    transition,
    visuallyHidden,
};
export default styleUtils;
